import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Only report web vitals in development
if (process.env.NODE_ENV === 'development') {
  reportWebVitals(console.log);
}
